
<template>
<div>
  <multiselect v-model="mutableSelectedUmfang" :show-labels="false" placeholder="Umfang auswählen" :options="allumfaenge" :multiple="false"  track-by="id" label="name" :close-on-select="true"></multiselect>
  <b-button class="button is-small is-white" @click="addU">
    <b-icon custom-size="mdi-18px" type="is-black" icon="plus-circle"></b-icon>
    <span style="position: relative;left: 2px;top: -2px;">Neuen Umfang anlegen</span>
  </b-button>

  <b-modal :active.sync="createUmfang" has-modal-card>
     <div class="modal-card" style="width: auto">
      <header class="modal-card-head">
              <p class="modal-card-title">Umfang hinzufügen</p>
      </header>
      <section class="modal-card-body">
        <b-field label="Name">
          <b-input  maxlength="255" v-model="newUmfang.name"></b-input>
        </b-field>
        <b-field label="Code">
          <b-input  maxlength="255" v-model="newUmfang.code"></b-input>
        </b-field>
        <b-field label="Sortierung">
          <b-numberinput v-model="newUmfang.frontendorder"></b-numberinput>
        </b-field>

      </section>

      <footer class="modal-card-foot">
              <b-button class="button is-primary" @click="addUmfang">Übernehmen</b-button>
      </footer>
    </div>
  </b-modal>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
const axios = require('axios');

    export default {
      props: ['selectedumfang'],
      components: {
      	Multiselect
    	},
        data(){
          return {
            allumfaenge: [],
            categories: [],
            createUmfang: false,
            mutableSelectedUmfang: this.selectedumfang,
            newUmfang: {
              frontendorder: 1,
              name: "",
              code: ""
            }
          }
        },
        watch: {
          selectedumfang(val) {
              this.mutableSelectedUmfang = val;
          },
          mutableSelectedUmfang(val) {
            console.log("CHANEE");
            this.$emit('input', val);
          }
        },
        mounted() {
          console.log('Component mounted3.');
          //Get Umfang
          this.getUmfaenge();

        },
        methods: {
          addU: function() { //Popop öffnen und
            this.createUmfang = true;
          },
          addUmfang: function() { //Ajax-Call zum Speichern
            if ((this.newUmfang.name) && (this.newUmfang.frontendorder) && (this.newUmfang.code)){
              console.log(this.newUmfang);
              this.allumfaenge.push(this.newUmfang);
              this.mutableSelectedUmfang = this.newUmfang;
              this.createUmfang = false;
            }  else {
              console.log("err");
              this.$buefy.dialog.alert({
                            title: 'Fehler',
                            message: 'Bitte alle Felder ausfüllen.',
                            type: 'is-danger',
                            hasIcon: true,
                            icon: 'alert-circle',
                            iconPack: 'mdi'
                        });
            }
      		},

          getUmfaenge: function() {
            var _this = this;
            axios.get('/api/items', {
              withCredentials: true,
            })
            .then(function (response) {
              console.log(response.data);
              _this.allumfaenge = response.data;
              //_this.loading = false;
            })
            .catch(function (error) {
              console.log(error);
              //  _this.loading = false;
            })
            .then(function () {
              // always executed
            });
          }
        },
      }

</script>
